import { mapActions } from "vuex";

export default {
    created() {

    },
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                const traslados_nuevos = []
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'editarAportesFtn':
                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_activos'] })
                            await this.updateDataPost({ state: 'tablaDelete', data: [] })
                            await this.updateDataPost({ state: 'route', data: 'save_all' })
                            break
                        case 'registrarPLanillaFtn':
                            let datos_afiliado = []
                            let info_afiliacion = []
                            let aportes_registro = []
                            let servicios_activos = []
                            let servicios_nuevos = []
                            let servicios_inits = []
                            let info_aportes = []

                            let retirados = this.tableSave.tableGetRetiros.btn0
                            for (let i = 0; i < retirados.length; i++) {
                                if (retirados[i].check) {
                                    let dataFrontend = this.dataGet[this.namePath].data[retirados[i].index]
                                    datos_afiliado.push(dataFrontend.datos_afiliado)
                                    info_afiliacion.push(dataFrontend.info_afiliacion)
                                    aportes_registro.push(dataFrontend.aportes_registro)
                                    if (dataFrontend.info_aportes) {
                                        for (let j = 0; j < dataFrontend.info_aportes.length; j++) {
                                            dataFrontend.info_aportes[j].nota_delete = 'Retiro masivo'
                                            info_aportes.push(dataFrontend.info_aportes[j])
                                        }
                                    }
                                    for (let j = 0; j < dataFrontend.servicios_activos.length; j++) {
                                        servicios_activos.push(dataFrontend.servicios_activos[j])
                                        if (dataFrontend.servicios_activos[j].name !== 'Traslado') {
                                            let inits = this.deepCopy(dataFrontend.servicios_activos[j])
                                            inits.id = null
                                            inits.deleted_at = this.fecha().fecha.hoy
                                            inits.nota_delete = 'Retiro archivo retiros'
                                            servicios_inits.push(inits)
                                        } else if (dataFrontend.servicios_activos[j].nota_delete === null) {
                                            dataFrontend.servicios_activos[j].id = null
                                            dataFrontend.servicios_activos[j].iniciolabores = null
                                            dataFrontend.servicios_activos[j].retiro = null
                                            traslados_nuevos.push(dataFrontend.servicios_activos[j])
                                        }
                                    }
                                    for (let j = 0; j < dataFrontend.servicios_nuevos.length; j++) {
                                        if (dataFrontend.servicios_nuevos[j].name !== 'Traslado') {
                                            servicios_nuevos.push(dataFrontend.servicios_nuevos[j])
                                        }
                                    }
                                }
                            }

                            await this.updateDataForm({ state: 'datos_afiliado', data: datos_afiliado })
                            await this.updateDataForm({ state: 'info_afiliacion', data: info_afiliacion })
                            await this.updateDataForm({ state: 'aportes_registro', data: aportes_registro })
                            await this.updateDataForm({ state: 'servicios_activos', data: servicios_activos })
                            await this.updateDataForm({ state: 'servicios_nuevos', data: servicios_nuevos })
                            await this.updateDataForm({ state: 'servicios_inits', data: servicios_inits })
                            await this.updateDataForm({ state: 'info_aportes', data: info_aportes })

                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaAuditar: true,
                                    notaDelete: null,
                                    tablaPost: ['datos_afiliado', 'info_afiliacion', 'aportes_registro', 'servicios_activos', 'servicios_nuevos', 'servicios_inits', 'info_aportes'],
                                    tablaDelete: ['info_afiliacion', 'servicios_activos', 'servicios_nuevos', 'info_aportes']
                                }
                            })
                            break
                        case 'btn0':
                            await this.updateGlobal({
                                state: 'openModal/modal',
                                data: { value: true, title: 'Registrar No de planilla', modal: 'Planilla', data: { mes: this.filter.mes_periodo.id, ano: this.filter.ano_periodo.id, razon: this.filter.id_datos_razon.id } }
                            })
                            return true
                            break
                        case 'anularRegistroFtn':
                            await this.updateDataForm({ state: 'info_ingresos/anulado', data: 1 })
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaAuditar: true,
                                    notaDelete: this.dataForm[this.namePath].info_ingresos.nota_delete,
                                    tablaPost: ['info_ingresos'],
                                    tablaDelete: ['info_ingresos']
                                }
                            })

                            break;
                    }
                }

                await this.save(event.save)

                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'registrarPLanillaFtn':
                            if (traslados_nuevos.length > 0) {
                                await this.updateDataPost({
                                    data: {
                                        data: [{ servicios_nuevos: traslados_nuevos }],
                                        route: 'save_all',
                                        tablaAuditar: true,
                                        notaDelete: null,
                                        tablaPost: ['servicios_nuevos'],
                                        tablaDelete: []
                                    }
                                })
                                await this.save(event.save)
                            }
                            break
                    }
                }

                this.getFiltrar()
                    // frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
                const await31 = this.resetDataIndex()
                const await32 = this.resetGlobal({ state: 'openModal' })
                const await33 = this.resetDataForm()
                const await34 = this.resetGlobal({ state: 'saveConfig/capa' })
                await Promise.all([await31, await32, await33, await34])
            } catch (e) {
                console.log(e)
            }
        }
    },
}